import React from 'react';

import { SpacingSystemType } from '@rover/kibble/core/styledSystemPropTypes';
import Section from '@rover/kibble/patterns/Section';
import { SectionProps } from '@rover/kibble/patterns/Section/Section.common';

export const MOBILE_MARGIN_Y = '12x';
export const DESKTOP_MARGIN_Y = '24x';
export const SERVICE_LANDING_SECTION_MARGIN_Y: SpacingSystemType = [
  MOBILE_MARGIN_Y,
  DESKTOP_MARGIN_Y,
];

const ServiceLandingSection: React.FC<SectionProps> = (props) => (
  <Section my={SERVICE_LANDING_SECTION_MARGIN_Y} {...props} />
);

export default ServiceLandingSection;
